/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Loader from '../../../../components/Loader/Loader';
import { Box, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import { customSortHelper1, setDepartmentName } from '../../../../utils/Helper';
/* CSS */
import useStyles from '../../Main.style';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover'; /* eslint-disable-next-line */
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import { formatToCurrency, formatToNumber, getLoggedInUserData } from '../../../../utils/Helper';

const SummaryInvoiceByCountry = ({
  reportArr,
  myCountryInvoiceArray,
  myProfitRevenue,
  financialPerformanceCountryByYear,
  dashboardComments,
  dashboardSectionText,
}) => {
  const classes = useStyles();
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const loggedInUserData = getLoggedInUserData();
  const [isLoaded] = useState(true);

  async function findColumnObject(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findColumnObject(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findColumnObject(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase() == searchText.toLowerCase()
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  async function findObjectBySearchText(obj, searchText) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj };
            }
          }
        }
      }
    }
    return null;
  }

  const fillPastDueTotals = async (reportObj) => {
    const pastDueColumns = await findColumnObject(reportObj?.reportResult, 'Customer');

    let requiredColumnIndex = 0;
    pastDueColumns?.parent.map((c, i) => {
      if (c.ColTitle == '16 and over') {
        requiredColumnIndex = i;
      }
    });

    const pastDueInvTotalYtd = await findObjectBySearchText(reportObj?.reportResult, 'GrandTotal');
    const pastDueAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex];

    setPastDueInvoicesObject([
      ...pastDueInvoicesObject,
      { pastDueTotal: pastDueAmt?.value || 0, country: reportObj?.country },
    ]);
  };

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, []);

  return (
    <>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* PROFIT COMPONENT */}

        <Box className={classes.innercontentWhite} height="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5" noWrap>
              Invoicing -{' '}
              {setDepartmentName(
                loggedInUserData?.department?.departmentTitle,
                loggedInUserData?.roleId,
              ) + ' Logiware'}
            </Typography>
            <InfoPopover
              dashboardComments={dashboardComments}
              dashboardSectionText="Company Performance Invoice"
            />
          </Box>
          <Box mt={1} className={classes.TableUIV2}>
            <MaterialTable
              style={{ boxShadow: 'none' }}
              isLoading={myCountryInvoiceArray.length === 0 ? true : false}
              options={{
                toolbar: false,
                draggable: false,
                paging: false,
                sorting: true,
                pageSize: 20,
                pageSizeOptions: [10, 20, 50, 100],
                showTextRowsSelected: false,
                toolbarButtonAlignment: 'right',
                showFirstLastPageButtons: false,
                actionsColumnIndex: -100,
                emptyRowsWhenPaging: false,
              }}
              localization={{
                pagination: {
                  labelRowsSelect: 'Rows',
                  labelRowsPerPage: 'Rows Per Page',
                },
              }}
              title="Invoicing"
              columns={[
                {
                  title: new Date().getFullYear() + ' YTD',
                  field: 'ytd',
                  sorting: false,
                },
                {
                  title: 'United States',
                  field: 'usa',
                  customSort: (a, b) => customSortHelper1(a, b, 'usa1'),
                },
                {
                  title: 'Mexico',
                  field: 'mexico',
                  customSort: (a, b) => customSortHelper1(a, b, 'mexico1'),
                },
                {
                  title: 'Chile',
                  field: 'chile',
                  customSort: (a, b) => customSortHelper1(a, b, 'chile1'),
                },
                {
                  title: 'Peru',
                  field: 'peru',
                  customSort: (a, b) => customSortHelper1(a, b, 'peru1'),
                },
              ]}
              data={[
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: formatToCurrency(myCountryInvoiceArray?.[4]?.usa, classes),
                  usa1: myCountryInvoiceArray?.[4]?.usa,
                  //usa: formatToCurrency(financialPerformanceCountryByYear?.us?.revenue, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[4]?.mexico, classes),
                  mexico1: myCountryInvoiceArray?.[4]?.mexico,
                  chile1: myCountryInvoiceArray?.[4]?.chile,
                  peru1: myCountryInvoiceArray?.[4]?.peru,
                  chile: formatToCurrency(myCountryInvoiceArray?.[4]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[4]?.peru, classes),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue Target"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToCurrency(myCountryInvoiceArray?.[6]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[6]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[6]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[6]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[6]?.usa,
                  mexico1: myCountryInvoiceArray?.[6]?.mexico,
                  chile1: myCountryInvoiceArray?.[6]?.chile,
                  peru1: myCountryInvoiceArray?.[6]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue Target (Accumulated)"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToCurrency(myCountryInvoiceArray?.[10]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[10]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[10]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[10]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[10]?.usa,
                  mexico1: myCountryInvoiceArray?.[10]?.mexico,
                  chile1: myCountryInvoiceArray?.[10]?.chile,
                  peru1: myCountryInvoiceArray?.[10]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit"
                      title={dashboardSectionText}
                    />
                  ),
                  // usa: formatToCurrency(
                  //   financialPerformanceCountryByYear?.us?.grossProfit,
                  //   classes,
                  // ),
                  usa: formatToCurrency(myCountryInvoiceArray?.[5]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[5]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[5]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[5]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[5]?.usa,
                  mexico1: myCountryInvoiceArray?.[5]?.mexico,
                  chile1: myCountryInvoiceArray?.[5]?.chile,
                  peru1: myCountryInvoiceArray?.[5]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Target"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: formatToCurrency(myCountryInvoiceArray?.[7]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[7]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[7]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[7]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[7]?.usa,
                  mexico1: myCountryInvoiceArray?.[7]?.mexico,
                  chile1: myCountryInvoiceArray?.[7]?.chile,
                  peru1: myCountryInvoiceArray?.[7]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Target (Accumulated)"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToCurrency(myCountryInvoiceArray?.[11]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[11]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[11]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[11]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[11]?.usa,
                  mexico1: myCountryInvoiceArray?.[11]?.mexico,
                  chile1: myCountryInvoiceArray?.[11]?.chile,
                  peru1: myCountryInvoiceArray?.[11]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Average Gross Profit per File"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: formatToCurrency(myCountryInvoiceArray?.[3]?.usa, classes, ' /File'),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[3]?.mexico, classes, ' /File'),
                  chile: formatToCurrency(myCountryInvoiceArray?.[3]?.chile, classes, ' /File'),
                  peru: formatToCurrency(myCountryInvoiceArray?.[3]?.peru, classes, ' /File'),
                  //
                  usa1: myCountryInvoiceArray?.[3]?.usa,
                  mexico1: myCountryInvoiceArray?.[3]?.mexico,
                  chile1: myCountryInvoiceArray?.[3]?.chile,
                  peru1: myCountryInvoiceArray?.[3]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Weighted for Complexity"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: formatToCurrency(myCountryInvoiceArray?.[9]?.usa, classes),
                  mexico: formatToCurrency(myCountryInvoiceArray?.[9]?.mexico, classes),
                  chile: formatToCurrency(myCountryInvoiceArray?.[9]?.chile, classes),
                  peru: formatToCurrency(myCountryInvoiceArray?.[9]?.peru, classes),
                  //
                  usa1: myCountryInvoiceArray?.[9]?.usa,
                  mexico1: myCountryInvoiceArray?.[9]?.mexico,
                  chile1: myCountryInvoiceArray?.[9]?.chile,
                  peru1: myCountryInvoiceArray?.[9]?.peru,
                },

                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Active to Admin Delta"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToNumber(
                    myCountryInvoiceArray?.[1]?.usa,
                    classes,
                    myCountryInvoiceArray?.[1]?.type,
                  ),
                  mexico: formatToNumber(
                    myCountryInvoiceArray?.[1]?.mexico,
                    classes,
                    myCountryInvoiceArray?.[1]?.type,
                  ),
                  chile: formatToNumber(
                    myCountryInvoiceArray?.[1]?.chile,
                    classes,
                    myCountryInvoiceArray?.[1]?.type,
                  ),
                  peru: formatToNumber(
                    myCountryInvoiceArray?.[1]?.peru,
                    classes,
                    myCountryInvoiceArray?.[1]?.type,
                  ),
                  //
                  usa1: myCountryInvoiceArray?.[1]?.usa,
                  mexico1: myCountryInvoiceArray?.[1]?.mexico,
                  chile1: myCountryInvoiceArray?.[1]?.chile,
                  peru1: myCountryInvoiceArray?.[1]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Admin to Closed Delta"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToNumber(
                    myCountryInvoiceArray?.[2]?.usa,
                    classes,
                    myCountryInvoiceArray?.[2]?.type,
                  ),
                  mexico: formatToNumber(
                    myCountryInvoiceArray?.[2]?.mexico,
                    classes,
                    myCountryInvoiceArray?.[2]?.type,
                  ),
                  chile: formatToNumber(
                    myCountryInvoiceArray?.[2]?.chile,
                    classes,
                    myCountryInvoiceArray?.[2]?.type,
                  ),
                  peru: formatToNumber(
                    myCountryInvoiceArray?.[2]?.peru,
                    classes,
                    myCountryInvoiceArray?.[2]?.type,
                  ),
                  //
                  usa1: myCountryInvoiceArray?.[2]?.usa,
                  mexico1: myCountryInvoiceArray?.[2]?.mexico,
                  chile1: myCountryInvoiceArray?.[2]?.chile,
                  peru1: myCountryInvoiceArray?.[2]?.peru,
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Optimal Invoice Delta"
                      title={dashboardSectionText}
                    />
                  ),

                  usa: formatToNumber(
                    myCountryInvoiceArray?.[0]?.usa,
                    classes,
                    myCountryInvoiceArray?.[0]?.type,
                  ),
                  mexico: formatToNumber(
                    myCountryInvoiceArray?.[0]?.mexico,
                    classes,
                    myCountryInvoiceArray?.[0]?.type,
                  ),
                  chile: formatToNumber(
                    myCountryInvoiceArray?.[0]?.chile,
                    classes,
                    myCountryInvoiceArray?.[0]?.type,
                  ),
                  peru: formatToNumber(
                    myCountryInvoiceArray?.[0]?.peru,
                    classes,
                    myCountryInvoiceArray?.[0]?.type,
                  ),
                  //
                  usa1: myCountryInvoiceArray?.[0]?.usa,
                  mexico1: myCountryInvoiceArray?.[0]?.mexico,
                  chile1: myCountryInvoiceArray?.[0]?.chile,
                  peru1: myCountryInvoiceArray?.[0]?.peru,
                },
              ]}
            />
          </Box>
        </Box>
      </If>
    </>
  );
};

export default SummaryInvoiceByCountry;
